import React, { useCallback, useMemo } from "react";
import { Select } from "components/Select/Select";
import { useProductOutput, useProductActions } from "stores/product";
import { useTranslate } from "hooks/useTranslate";

type SelectOption = {
  label: string;
  value: string;
};

export const SelectStrategyInput = ({
  isDisabled = false,
}: {
  isDisabled?: boolean;
}) => {
  const translate = useTranslate();
  const productActions = useProductActions();
  const productOutput = useProductOutput();

  const strategyOptions: SelectOption[] = useMemo(() => {
    return (
      productOutput?.product?.availableStrategies?.map((strategy) => ({
        label: strategy?.presentation ?? "",
        value: strategy?.id ?? "",
      })) ?? []
    );
  }, [productOutput?.product?.availableStrategies]);

  const selectedStrategy =
    strategyOptions.find(
      (option) => option.value === productOutput?.product?.currentStrategyId,
    ) ?? null;

  const onChange = useCallback(
    (option: SelectOption | null) => {
      if (option?.value) {
        productActions.selectStrategy(option.value);
      }
    },
    [productActions],
  );

  return (
    <div className="border-bottom px-4 pb-2">
      <h5 className="mb-2 font16">
        {translate("PRODUCT_SUGGESTION_STRATEGY")}
      </h5>
      <Select
        name={"strategy-select"}
        data-recording-disable={true}
        options={strategyOptions}
        onChange={onChange}
        isDisabled={isDisabled}
        value={selectedStrategy}
        testId={productOutput?.product?.id}
        className="font-md"
      />
    </div>
  );
};
